<template>
    <div class="mask-clip" @click="pageClick">
        <!-- 已激活状态 -->
        <div class="clip-view ticket-size" 
             @click.stop="self"
             :style="{
                background: ticket?.coupon_type && `url(${require(`@/assets/images/YuliApp/CyberportCoupon/pop_bg_coupon_clip_type${ticket?.coupon_type}.png`)}) no-repeat top left`,
                backgroundSize: '100% 100%',
             }">
            <!-- 二维码 -->
            <div class="clip-view-codeView">
                <div class="clip-view-codeView-code" @click.stop="qrCodeHandle">
                    <!-- 二维码位置 -->
                    <img id="qrcode" :src="useQrCodePng" v-show="useQrCodePng">
                </div>
            </div>
            <!-- 下 -->
            <div class="clip-view-bottom">
                <div class="clip-view-bottom-label">{{ ticket?.title }}</div>
                <div class="clip-view-bottom-id">#{{ ticket?.id }}</div>
                <div class="button" @click.stop="ClipHandle">
                    Clip
                </div>
            </div>
        </div>
        <!-- close -->
        <div class="close-view" @click="handleClose">
            <div class="close-view-icon">
                <img class="close-view-icon-left" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
                <span class="close-view-icon-text">Click to close</span>
                <img class="close-view-icon-right" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, getCurrentInstance } from "vue";
import { mapState } from "vuex";
import QRCode from 'qrcode'
import { postUseTicket } from "@/api/cyberport.js"
import { ERROR_TEXT } from "@/constants/enums";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
components: {
},
props: {
    ticket: {
        type: Object,
        default: () => {
            return {}
        },
    },
},
watch: {
    ticket: {
        async handler(value) {
            console.log('ticket: ', value);
            if(!value)return;

            const params = {
                id: value.id,
                code: value.code,
                // created_at: value.created_at
            }

            QRCode.toDataURL(JSON.stringify(params) || 'code error', {
                width: 180,
                height: 180,
                color: {
                    dark: '#FFF5EDFF',
                    light: '#ffffff00'
                }
            })
            .then(url => {
                console.log(url);
                this.useQrCodePng = url;
            })
            .catch(err => {
                console.error(err)
            })
        },
        immediate: true,
        deep: true,
    },
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
    }),
},
setup(props, ctx) {
    const { proxy } = getCurrentInstance();
    const currentProp = ref(null);
    const useQrCodePng = ref(null);
    onMounted(() => {
        
    });

    /**
     * 处理关闭
     */
     const handleClose = () => {
      ctx.emit("msgHandle", 'reflash');
      ctx.emit("msgHandle", false);
    };

    const pageClick = () => {
        handleClose();
    }

    const qrCodeHandle = () => {
        console.log('qrCodeHandle');
    }

    const ClipHandle = async () => {
        const id = props?.ticket?.id + '';
        proxy.$loading.show();
        try {
            const res = await postUseTicket(id || '0', {
                id: id,
                value: props?.ticket?.code
            });
            console.log(res);
            proxy.$loading.hide();
            proxy.$toast.show({
                msg: 'Coupon Clip Success!',
                type: TOAST_TYPE.SUCCESS,
            });
            handleClose();
        } catch (error) {
            proxy.$loading.hide();
            proxy.$toast.show({
                msg: ERROR_TEXT.NEXTWORK_ERROR,
                type: TOAST_TYPE.ERROR,
            });
        }
        
    }

    return {
        handleClose,
        qrCodeHandle,
        ClipHandle,
        pageClick,
        currentProp,
        useQrCodePng
    };
},
};
</script>

<style lang="less">
    .mask-clip{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ticket-size{
        width: 320px;
        height: 440px;
        padding: 67px 40px 33px;
        box-sizing: border-box;
    }
    // 已激活
    .clip-view{
        background: url("~@/assets/images/YuliApp/CyberportCoupon/pop_bg_coupon_clip.png")
        no-repeat top left;
        background-size: 100% 100%;
        padding: 66px 0 30px;
        &-codeView{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 62px;
            &-code{
                width: 180px;
                height: 180px;
                // background-color: #000000;
            }
        }
        &-bottom{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-family: "PingFang SC";
            text-align: left;
            &-label{
                // color: #4f6942f2;
                color: rgba(234, 225, 218, 0.95);
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 18px;
            }
            &-id{
                // color: #677d70;
                color: rgba(234, 225, 218, 1);
                font-size: 15px;
                font-weight: 400;
                margin-bottom: 18px;
            }
        }     
    }
    .button{
        width: 128px;
        height: 38px;
        border-radius: 20px;
        border: 1px solid #73572e;
        background: #ffdb5b;
        color: #000000;
        font-size: 16px;
        font-weight: 600;
        font-family: "PingFang SC";
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .close-view{
        position: absolute;
        z-index: 999;
        width: 100%;
        display: flex;
        justify-content: center;
        bottom: 110px;
        img {
            width: 100%;
            height: 100%;
        }
        &-icon{
            width: 125px;
            height: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            &-text{
                width: 83px;
                height: 16px;
                // color: #bcc2c7;
                color: rgba(188, 194, 199, 1);
                font-size: 13px;
                font-weight: 400;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 15.6px;
            }
            img{
                width: 13px;
                height: 5.91px;
            }
            &-left{
                transform: rotateY(360deg);
            }
            &-right{
                transform: rotateY(180deg);
            }
        }
    }
    #qrcode{
        width: 100%;
        height: 100%;
    }
</style>